export function PlatformPlans() {
	return (
		<section className="workspace-section owner-plans-page">
			<div className="section-heading">
				<div>
					<p className="eyebrow">Platform administration</p>
					<h2>Plans</h2>
					<p className="muted">Configure customer plans and entitlements.</p>
				</div>
			</div>

			<section className="settings-card integration-panel owner-plans-panel">
				<div className="integration-panel-heading">
					<h4 className="panel-title">Plan configuration</h4>
					<p>This page is ready for plan configuration to be added later.</p>
				</div>
			</section>
		</section>
	);
}
